import React from "react";
import TextField from "@material-ui/core/TextField";
import styled from "styled-components";

const DefaultPhoneCel = ({ value, onChange, name, specialLabel = "" }) => {
    return (
        <Input
            variant="outlined"
            fullWidth
            type="tel"
            name={name}
            value={value}
            label={specialLabel}
            placeholder="Código de área sin 0 y número sin 15. Ej: 2615123456"
            onChange={e => {
                const onlyNumbers = e.target.value.replace(/\D/g, "");
                onChange(onlyNumbers);
            }}
            inputProps={{
                pattern: "[0-9]*",
                inputMode: "numeric",
                maxLength: 30
            }}
        />
    );
};

const DefaultPhoneFijo = ({ value, onChange, name, specialLabel = "" }) => {
    return (
        <Input
            variant="outlined"
            fullWidth
            type="tel"
            name={name}
            value={value}
            label={specialLabel}
            placeholder="Ej: 4223344"
            onChange={e => {
                const onlyNumbers = e.target.value.replace(/\D/g, "");
                onChange(onlyNumbers);
            }}
            inputProps={{
                pattern: "[0-9]*",
                inputMode: "numeric",
                maxLength: 30
            }}
        />
    );
};



export { DefaultPhoneFijo, DefaultPhoneCel }

const Input = styled(TextField)`
    width: 100%;
    min-width: 100%;
`;